import { FaEdit, FaTrash } from 'react-icons/fa';
import ActiveInactiv from '../../../../../data/activeInactive';

import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '../../../../../../redux/store';
import ModalBootstrap from '../../../../../data/Modal';
import { notify, notifyError } from '../../../../../notify/notify-component';
import { useState } from 'react';
import Format from '../../../../../../Services/Format';
import DateUtils from '../../../../../../Services/DateUtils';
import { deletePAymentTypesync, getPAymentTypesync } from '../../../../../../redux/features/paymentType/services';

interface Props {
  key?: any;
  paymentTypes: any;
  handleEdit: any;
  OnAddNewCategorie: (e: boolean) => void;
}

export function TreePDV({ paymentTypes, handleEdit }: Props) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const dispatch = useDispatch<AppDispatch>();

  const [modalConfirmation, setModalConfirmation] = useState<boolean>(false);
  const [uuid, setUuid] = useState<string>("");

  const handleDelete = async (uuid: string) => {
    dispatch(deletePAymentTypesync(uuid)).then((result: any) => {
      if (deletePAymentTypesync.fulfilled.match(result)) {
        notify("Recebimento excluido.");
        dispatch(getPAymentTypesync(storeMe?.storeActive?.id));
      } else {
        notifyError("Erro ao excluir item.");
      }
    });
  };

  const handleModalUuid = (uuid: string) => {
    setUuid(uuid);
    setModalConfirmation(true);
  };

  const handleDeleteItem = () => {
    setModalConfirmation(false);
    handleDelete(uuid);
  };

  return (
    <>
      <ModalBootstrap
        state={modalConfirmation}
        setState={setModalConfirmation}
        text={"Certeza que deseja excluir?"}
        handleAction={handleDeleteItem}
      />
      <div
        className="row ItemTree"
        style={{
          paddingTop: "10px",
          paddingLeft: "2rem",
          fontFamily: "Open Sans",
          fontWeight: "normal",
          
        }}
      >
        <div>
          <section>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 2fr 2fr 2fr 1fr 1fr 2fr",
                flex: "1",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              <div>
                {Format.date(
                  DateUtils.toDate(paymentTypes?.created_at),
                  "DD/MM/YYYY",
                )}
              </div>
              <div>{paymentTypes?.id_pdv_payment_type}</div>
              <div>{paymentTypes?.description}</div>
              <div>
                {paymentTypes?.relationships.chart_account?.description ??
                  "---"}
              </div>
              <div style={{ paddingLeft: "15px" }}>
                {paymentTypes?.terminate_days ?? "---"}
              </div>
              <div style={{ paddingLeft: "30px" }}>
                {(paymentTypes?.tax?.toString()?.replace(".", ",") ?? "---") + "%"}
              </div>

              <span style={{ maxWidth: "55px", marginLeft: "1rem" }}>
                {paymentTypes?.is_active ? (
                  <ActiveInactiv
                    status={paymentTypes?.is_active}
                    text="Ativo"
                  />
                ) : (
                  <ActiveInactiv
                    status={paymentTypes?.is_active}
                    text="Inativo"
                  />
                )}
              </span>

              <div>
                <button style={{ margin: "0 15px" }}>
                  <FaEdit
                    size={16}
                    color="8e8d8d"
                    onClick={() => handleEdit(paymentTypes)}
                  />
                </button>
                <button>
                  <FaTrash
                    size={14}
                    color="8e8d8d"
                    onClick={() => handleModalUuid(paymentTypes.uuid)}
                  />
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
